import { TripType } from '@honeycomb/data';
export function getFilghtUpsellUpdatedState(state, estabId, name, isCached, isCacheEnabled) {
    const parsedEstabId = parseInt(estabId);
    const updatedState = Object.assign(Object.assign({}, state), { tripType: TripType.Holiday });
    if (isCacheEnabled) {
        return Object.assign(Object.assign({}, updatedState), { destinations: [
                {
                    id: parsedEstabId,
                    type: 1,
                    title: name !== null && name !== void 0 ? name : '',
                    isCached,
                },
            ], destinationIds: null, destinationTitle: '', hotelIds: null, hotelTitle: '' });
    }
    const hasDestinationIds = updatedState.destinationIds && updatedState.destinationIds.length > 0;
    if (hasDestinationIds) {
        return Object.assign(Object.assign({}, updatedState), { destinations: null, destinationIds: null, destinationTitle: null, hotelIds: [parsedEstabId], hotelTitle: name });
    }
    return updatedState;
}
